export default __webpack_public_path__ + "static/media/facebook2.ff9c6f85.svg";